import { render, staticRenderFns } from "./Debugger.vue?vue&type=template&id=01f88ddb"
import script from "./Debugger.vue?vue&type=script&lang=js"
export * from "./Debugger.vue?vue&type=script&lang=js"
import style0 from "./Debugger.vue?vue&type=style&index=0&id=01f88ddb&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f88ddb')) {
      api.createRecord('01f88ddb', component.options)
    } else {
      api.reload('01f88ddb', component.options)
    }
    module.hot.accept("./Debugger.vue?vue&type=template&id=01f88ddb", function () {
      api.rerender('01f88ddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Debugger.vue"
export default component.exports